module.exports = __webpack_public_path__ + "img/salsa_4347.2f0706fc.jpg";